import { ReactElement } from 'react';
import { CompoundComponent } from 'ia-react-core/~/interfaces/CompoundComponent';

export const LeftContent = ({ children }: CompoundComponent) => children as ReactElement;
LeftContent.type = Symbol('MainHeader.LeftContent');

export const MiddleContent = ({ children }: CompoundComponent) => children as ReactElement;
MiddleContent.type = Symbol('MainHeader.MiddleContent');

export const RightContent = ({ children }: CompoundComponent & { noColPadding?: boolean; noClosePadding?: boolean }) => children as ReactElement;
RightContent.type = Symbol('MainHeader.LeftContent');
